import { render, staticRenderFns } from "./ServiceTakerAllocationBlankslate.vue?vue&type=template&id=7eac8700&"
import script from "./ServiceTakerAllocationBlankslate.vue?vue&type=script&lang=js&"
export * from "./ServiceTakerAllocationBlankslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports